var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.167 5.00012H1.833C1.37295 5.00012 1 5.37307 1 5.83312V12.5001C1 13.8808 2.11929 15.0001 3.5 15.0001H8.5C9.16304 15.0001 9.79893 14.7367 10.2678 14.2679C10.7366 13.799 11 13.1632 11 12.5001V5.83312C11 5.37307 10.6271 5.00012 10.167 5.00012Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.00008L8.894 2.78908C8.3459 1.69263 7.22531 1 5.9995 1C4.77369 1 3.6531 1.69263 3.105 2.78908L3 3.00008H9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    d: "M5.083 8.33312C5.083 7.91891 4.74721 7.58312 4.333 7.58312C3.91879 7.58312 3.583 7.91891 3.583 8.33312H5.083ZM3.583 11.6661C3.583 12.0803 3.91879 12.4161 4.333 12.4161C4.74721 12.4161 5.083 12.0803 5.083 11.6661H3.583ZM8.417 8.33312C8.417 7.91891 8.08121 7.58312 7.667 7.58312C7.25279 7.58312 6.917 7.91891 6.917 8.33312H8.417ZM6.917 11.6661C6.917 12.0803 7.25279 12.4161 7.667 12.4161C8.08121 12.4161 8.417 12.0803 8.417 11.6661H6.917ZM9 2.25012C8.58579 2.25012 8.25 2.58591 8.25 3.00012C8.25 3.41434 8.58579 3.75012 9 3.75012V2.25012ZM11 3.75012C11.4142 3.75012 11.75 3.41434 11.75 3.00012C11.75 2.58591 11.4142 2.25012 11 2.25012V3.75012ZM3 3.75012C3.41421 3.75012 3.75 3.41434 3.75 3.00012C3.75 2.58591 3.41421 2.25012 3 2.25012V3.75012ZM1 2.25012C0.585786 2.25012 0.25 2.58591 0.25 3.00012C0.25 3.41434 0.585786 3.75012 1 3.75012V2.25012ZM3.583 8.33312V11.6661H5.083V8.33312H3.583ZM6.917 8.33312V11.6661H8.417V8.33312H6.917ZM9 3.75012H11V2.25012H9V3.75012ZM3 2.25012H1V3.75012H3V2.25012Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.04e41263d9ec8bdbb063b8faf0f52a1f.svg";
export { ForwardRef as ReactComponent };